import { Outlet, NavLink, useNavigate } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../Hooks/redux";
import { logoutRequest, selectUser } from "../Redux/AuthRedux";

/**
 * Shared application layout — header, navigation, user info, and main area.
 */
const NAV_ITEMS = [
  { path: "/", label: "Dub Video", end: true },
  { path: "/dashboard", label: "Dashboard", end: false },
  { path: "/docs", label: "API", end: false },
  { path: "/settings", label: "Settings", end: false },
];

export default function AppLayout() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const user = useAppSelector(selectUser);

  const handleLogout = () => {
    dispatch(
      logoutRequest({
        callback: () => navigate("/login"),
      }),
    );
  };

  return (
    <div className="min-h-screen flex flex-col bg-background">
      <header className="bg-card border-b border-muted-bg sticky top-0 z-50">
        <div className="max-w-6xl mx-auto px-6 h-[72px] flex items-center gap-8">
          <NavLink to="/" className="flex items-center">
            <img src="/logo.svg" alt="Dubvid" className="h-8" />
          </NavLink>

          <nav className="flex gap-2">
            {NAV_ITEMS.map(({ path, label, end }) => (
              <NavLink
                key={path}
                to={path}
                end={end}
                className={({ isActive }) =>
                  `px-4 py-2 rounded-[12px] text-base font-medium transition-colors ${
                    isActive
                      ? "bg-primary/10 text-primary"
                      : "text-muted hover:bg-secondary hover:text-foreground"
                  }`
                }
              >
                {label}
              </NavLink>
            ))}
          </nav>

          <div className="ml-auto flex items-center gap-4">
            {user && (
              <div className="flex items-center gap-3 hidden sm:flex">
                <div className="flex items-center gap-1.5 bg-primary/10 px-3 py-1.5 rounded-[10px]">
                  <svg className="w-4 h-4 text-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                  <span className="text-sm font-semibold text-primary">
                    {(user.credit_balance ?? 0).toFixed(1)}
                  </span>
                  <span className="text-xs text-primary/70">credits</span>
                </div>
                <span className="text-sm text-muted truncate max-w-[180px]">
                  {user.email}
                </span>
              </div>
            )}
            <button
              type="button"
              className="px-4 py-2 text-sm font-medium rounded-[12px] border border-muted-bg text-foreground hover:bg-secondary transition-colors"
              onClick={handleLogout}
            >
              Logout
            </button>
          </div>
        </div>
      </header>

      <main className="flex-1 max-w-6xl w-full mx-auto px-6 py-10">
        <Outlet />
      </main>
    </div>
  );
}
